import {Component, Input, OnInit} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {StudentTicketService} from '../../../@core/services/student-ticket/student-ticket.service';
import {StudentTicketAttachmentDto} from '../../../models/student-ticket/StudentTicketAttachmentDto';
import {AttachmentType} from '../../../models/antrag-ticket/AttachmentType';
import {TranslatePipe} from '@ngx-translate/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-student-ticket-attachments',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    TranslatePipe,
    FaIconComponent,
  ],
  templateUrl: './student-ticket-attachments.component.html',
  styleUrl: './student-ticket-attachments.component.scss'
})
export class StudentTicketAttachmentsComponent implements OnInit {

  @Input() ticketId: string;

  attachments: StudentTicketAttachmentDto[] = [];
  isLoading = false;

  readonly faDownload = faDownload;

  constructor(
    private readonly studentTicketService: StudentTicketService,
  ) {}

  ngOnInit(): void {
    this.loadAttachments();
  }

  loadAttachments(): void {
    if (!this.ticketId) return;
    this.isLoading = true;
    this.studentTicketService.getAttachments(this.ticketId).subscribe({
      next: (attachments) => {
        this.attachments = attachments || [];
        this.isLoading = false;
      },
      error: () => {
        this.attachments = [];
        this.isLoading = false;
      }
    });
  }

  downloadAttachment(attachment: StudentTicketAttachmentDto): void {
    this.studentTicketService.downloadAttachment(this.ticketId, attachment.attachmentId, attachment.fileName);
  }

  getBadgeClass(type: AttachmentType | string): string {
    switch (type) {
      case AttachmentType.AENDERUNGSBESCHEID:
        return 'badge-aenderung';
      case AttachmentType.KUENDIGUNGSBESCHEID:
        return 'badge-kuendigung';
      default:
        return 'badge-other';
    }
  }
}
